<template>
    <v-dialog
            :value="value"
            width="500"
            v-on="$listeners"
    >
        <v-card>
            <v-card-title
                    class="headline"
                    primary-title
            >
                {{__('dialogs.intro_title')}}
            </v-card-title>

            <v-card-text>
                {{__('dialogs.intro_text')}}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="primary"
                        flat
                        @click="$emit('input', false)"
                >
                    {{__('general.ok')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "IntroDialog",
        props: {
            value: Boolean
        }
    }
</script>

<style scoped>

</style>